import React from "react";
import _ from "lodash";

import DateControl from "./Date";

export default class MultipleDateControl extends React.PureComponent {
  handleRemove(date) {
    const { onChange, value } = this.props;
    onChange && onChange(value.filter((d) => d !== date));
  }

  render() {
    const { onFocus, onBlur, onChange, value, required, readOnlyValues = [], ...rest } = this.props;
    if (!Array.isArray(value)) {
      throw new Error("passed 'value' argument is not an array");
    }

    const handleDateChange = (newV) => {
      const isIncluded = value.includes(newV);
      const nextValue = _(value)
        .filter((v) => v !== newV)
        .concat(isIncluded ? [] : [newV])
        .sortBy((v) => new Date(v).getTime())
        .value();
      onChange(nextValue);
    };

    return (
      <div className="MultipleDateControl">
        <a className="ui label with-icon" onClick={() => this._newInputRef && this._newInputRef.click()}>
          <i className="icon material-icons">add</i>
          <span className="text">{I18n.t("papp.components.MultipleDateFormControl.add_new")}</span>
        </a>
        <div className="hidden-control">
          <DateControl
            {...rest}
            value={null}
            inputRef={(ref) => (this._newInputRef = ref)}
            onFocus={onFocus}
            onBlur={onBlur}
            onChange={handleDateChange}
            isDayHighlighted={(day) => value.includes(day.format(moment.RUBY_DATE_FORMAT))}
            placeholder={I18n.t("papp.components.MultipleDateFormControl.add_new")}
            required={required && value.length === 0}
          />
        </div>
        {value.map((v) => (
          <div key={v} className="ui label">
            {v}
            {!readOnlyValues.includes(v) && <i className="close icon" onClick={this.handleRemove.bind(this, v)}></i>}
          </div>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/MultipleDate.jsx